// extracted by mini-css-extract-plugin
export default {"galeria":"Galeria_galeria__6cEn4","container":"Galeria_container__I3cwO","slider":"Galeria_slider__KuWPx","content":"Galeria_content__sbp4u","img":"Galeria_img__4MNxc"};